import { AbstractControl } from "@angular/forms";

export class FormHelper {
  public static setFieldDisabledStatus(control: AbstractControl, isEnabled: boolean) {
    if (!control) {
      return;
    }
    if (isEnabled) {
      control.enable();
    } else {
      control.disable();
    }
  }

  public static hasErrorStatusToShow(control: AbstractControl) {
    if (!control) {
      return true;
    }
    return !control.valid && (control.touched || !control.pristine);
  }
}